import React, { Component } from "react";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
import MapPage from "./MapPage";
import { Link } from "react-router-dom";
import "./ContactSection.css";

export default class ContactSection2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      captcha: null,
      isSending: false,
    };
  }

  sendEmail = (e) => {
    e.preventDefault();

    if (!this.state.captcha) {
      alert("נא לאשר שאתה לא רובוט 🤖");
      return;
    }

    if (this.state.isSending) {
      return;
    }

    this.setState({
      isSending: true,
    });

    emailjs
      .sendForm(
        "service_udygc8r",
        "template_6fuh7lc",
        e.target,
        "user_7XjWzaNdKiGR2BG0wBiLt"
      )
      .then(
        () => {
          alert("ההודעה נשלחה בהצלחה , נחזור בהקדם האפשרי 👍");

          e.target.reset();

          this.setState({
            captcha: null,
            isSending: false,
          });
        },
        () => {
          alert("הודעה לא נשלחה, נסה שוב");

          this.setState({
            isSending: false,
          });
        }
      );
  };

  handleCaptchaChange = (value) => {
    this.setState({
      captcha: value,
    });
  };

  render() {
    const { isSending } = this.state;

    return (
      <section>
        <div className="ContactSection2-page">
          <div className="ContactSection2-hero">
            <div className="ContactSection2-overlay">
              <h1>צור קשר</h1>
            </div>
          </div>
        </div>

        <div className="page4">
          <div className="breadcrumb4">
            <Link to="/">בית</Link> /{" "}
            <Link to="/ContactSection2">צור קשר</Link>
          </div>
        </div>

        <div className="all">
          <div className="content-row">
            <form
              onSubmit={this.sendEmail}
              style={{
                width: "100%",
                maxWidth: "620px",
                marginLeft: "auto",
                padding: "25px",
                borderRadius: "20px",
                background: "rgba(255,255,255,0.85)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
                border: "1px solid rgba(0,0,0,0.08)",
              }}
            >
              <div>
                <h2
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    marginBottom: "25px",
                    fontSize: "30px",
                    background:
                      "linear-gradient(90deg,#0693e3,#001f3f)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  השאירו פרטים ונחזור אליכם
                </h2>

                <input
                  type="text"
                  name="name"
                  placeholder="שם מלא"
                  required
                  disabled={isSending}
                  style={inputStyle}
                />

                <input
                  type="tel"
                  name="phone"
                  placeholder="טלפון"
                  disabled={isSending}
                  style={inputStyle}
                />

                <textarea
                  name="message"
                  placeholder="איך נוכל לעזור?"
                  rows="6"
                  required
                  disabled={isSending}
                  style={{
                    ...inputStyle,
                    resize: "none",
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                    opacity: isSending ? 0.6 : 1,
                    pointerEvents: isSending ? "none" : "auto",
                  }}
                >
                  <ReCAPTCHA
                    sitekey="6LdxKdUdAAAAAGOyVnl1Fs8_GimLD8I8ELh4KDhW"
                    onChange={this.handleCaptchaChange}
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSending}
                  className={`contact-submit ${
                    isSending ? "sending" : ""
                  }`}
                >
                  {isSending ? (
                    <>
                      <span className="contact-spinner"></span>
                      <span>שולח...</span>
                    </>
                  ) : (
                    "שלחו פרטים"
                  )}
                </button>
              </div>
            </form>

            <div className="side-box">
              <img
                src="/logo.png"
                alt="איטומים בי"
                className="logo-top"
              />

              <div className="card">
                <div className="card-content">
                  <p>
                    רח׳ הסומך 6,
                    <br />
                    בני ברק
                  </p>

                  <p>052-6422426</p>

                  <p>
                    אימייל:
                    <br />
                    itumimbgvahim@gmail.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <MapPage />
      </section>
    );
  }
}

const inputStyle = {
  width: "100%",
  marginBottom: "15px",
  padding: "14px",
  borderRadius: "12px",
  border: "1px solid #e5e5e5",
  background: "#f9fafb",
  fontSize: "16px",
  textAlign: "right",
  outline: "none",
  boxSizing: "border-box",
};
